import React from 'react';
import { SelectBox } from 'devextreme-react/select-box';
import { VehicleDriverComponent } from '../VehicleDriverComponent';

const OtherDetailsCard = React.memo(function OtherDetailsCard({
  state,
  errors,
  onChange,
  onAffiliateChange,
  vehicleDriverRef,
  onNotesTabChange,
}) {
  const { notesTab = 'trip' } = state;

  return (
    <div className="rx-card">
      <div className="rx-card-line rx-cl-green" />
      <div className="rx-card-hd">
        <span className="rx-card-ico rx-ico-green"><i className="fas fa-sticky-note" /></span>
        <span className="rx-card-title">Other Details &amp; Notes</span>
      </div>
      <div className="rx-card-body">
        {/* Aff Booking No */}
        <div className="rx-fg" style={{ marginBottom: 8 }}>
          <label>Aff. Booking No.</label>
          <input type="text" className="rx-ff" name="affBookingNo" maxLength="100" title="Aff Booking No" value={state.affBookingNo} onChange={onChange} placeholder="Enter affiliation booking no." />
        </div>

        {/* Service Source */}
        <div className="rx-cols-2" style={{ marginBottom: 10 }}>
          <div className="rx-fg">
            <label>Service Source</label>
            <select className="rx-ff" name="serviceSourceId" value={state.serviceSourceId} onChange={onChange} disabled={true}>
              <option value="1">In House</option>
              <option value="2">Farm In</option>
              <option value="3">Farm Out</option>
            </select>
          </div>
          {state.serviceSourceId != 1 && (
            <div className="rx-fg">
              <label>Affiliate <span className="req">*</span></label>
              <SelectBox
                dataSource={state.dropdownAffiliates.length > 0 ? state.dropdownAffiliates : []}
                placeholder="Select affiliate"
                name="otherAffiliateId"
                defaultValue={0}
                value={state.otherAffiliateId}
                displayExpr="name"
                valueExpr="id"
                onSelectionChanged={onAffiliateChange}
                showClearButton={true}
                searchEnabled={true}
              />
              {errors.otherAffiliateId.length > 0 && <span className="rx-err">{errors.otherAffiliateId}</span>}
            </div>
          )}
        </div>

        {/* Vehicle / Driver */}
        <div className="rx-cols-2">
          <VehicleDriverComponent ref={vehicleDriverRef} />
        </div>

        {/* Notes tabs */}
        <div style={{ marginTop: 12 }}>
          <div className="rx-tab-bar">
            <button type="button" className={`rx-tab-b${notesTab === 'trip' ? ' active' : ''}`} onClick={() => onNotesTabChange('trip')}>Trip</button>
            <button type="button" className={`rx-tab-b${notesTab === 'bill' ? ' active' : ''}`} onClick={() => onNotesTabChange('bill')}>Bill To</button>
            <button type="button" className={`rx-tab-b${notesTab === 'pickup' ? ' active' : ''}`} onClick={() => onNotesTabChange('pickup')}>Pick-up</button>
          </div>
          <div className="rx-notes-wrap">
            {notesTab === 'trip' && (
              <textarea className="rx-notes-textarea" name="specialInstruction" placeholder="Enter special instruction…" maxLength="500" title="Special Instruction" value={state.specialInstruction} onChange={onChange} />
            )}
            {notesTab === 'bill' && (
              <textarea className="rx-notes-textarea" name="billToNotes" placeholder="Enter bill to notes…" maxLength="1000" title="Bill To Notes" value={state.billToNotes} onChange={onChange} />
            )}
            {notesTab === 'pickup' && (
              <textarea className="rx-notes-textarea" name="pickupNotes" placeholder="Enter pick-up notes…" maxLength="1000" title="Pick-up Notes" value={state.pickupNotes} onChange={onChange} />
            )}
          </div>
          <div className="rx-remark-wrap">
            <div className="rx-remark-label">Permanent Remark</div>
            <textarea className="rx-remark-textarea" name="permanentRemark" placeholder="Enter permanent remark…" maxLength="500" title="Permanent Remark" value={state.permanentRemark} onChange={onChange} />
          </div>
        </div>
      </div>
    </div>
  );
});

export default OtherDetailsCard;
